export const CHECKOUT_FETCH_REQUEST = 'checkout-fetch-request';
export const CHECKOUT_FETCH_SUCCESS = 'checkout-fetch-success';
export const CHECKOUT_FETCH_FAILURE = 'checkout-fetch-failure';